module.exports = "https://cdn.dove.it/_next/static/public/assets/adv/sell-property.4b02e4287c2d4306610dac85b9704b20.jpg";